module.exports = __webpack_public_path__ + "3912b9f1c23b88dce49d21f6a087cd58.MP3";